import React from 'react';
import { Box, ChevronRightIcon, Inscription } from '@common-fe/common-fe';
import styled from 'styled-components';

import { EMPTY_FIELD_VALUE } from '@/common/constants';

const EllipsisText = styled(Inscription)<{ hasUppercase?: boolean }>`
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  &:first-letter {
    ${({ hasUppercase = true }) => {
      if (hasUppercase) return 'text-transform: uppercase;';
      return '';
    }};
  }
`;

interface Props {
  fieldName?: string;
  oldValue?: string;
  newValue?: string;
  asHeader?: boolean;
  testId?: string;
}

export const ChangeSetLogItem: React.FC<Props> = ({ testId, fieldName, oldValue, newValue, asHeader }) => {
  return (
    <Box
      key={testId}
      data-testId={`ChangeSetLogItem_${testId}`}
      direction="row"
      height="40px"
      align="center"
      pad={{ left: 'spacing12', right: 'spacing16' }}
    >
      <Box width="26%">
        <EllipsisText title={fieldName} color="textSecondary" truncate>
          {fieldName}
        </EllipsisText>
      </Box>
      <Box width="37%" pad={{ left: 'spacing24' }}>
        <EllipsisText
          truncate
          color="textBody"
          hasUppercase={false}
          {...asHeader ? { weight: 'bold' } : {}}
          {...(oldValue === EMPTY_FIELD_VALUE || !oldValue ? {} : { title: oldValue })}
        >
          {oldValue || EMPTY_FIELD_VALUE}
        </EllipsisText>
      </Box>
      <Box width="37%" pad={{ left: '36px' }} justify="center" style={{ position: 'relative' }}>
        {asHeader ? null : (
          <ChevronRightIcon
            size="8px"
            color="iconSecondary"
            style={{ position: 'absolute', marginLeft: '-20px' }}
          />
        )}
        <EllipsisText
          truncate
          color="textBody"
          weight="bold"
          hasUppercase={false}
          {...(newValue === EMPTY_FIELD_VALUE || !newValue ? {} : { title: newValue })}
        >
          {asHeader ? '' : newValue || EMPTY_FIELD_VALUE}
        </EllipsisText>
      </Box>
    </Box>
  );
};
